import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useGameSelector } from '@sorrem-client/ui/hooks';
import { TargetEssenceBar } from '../TargetEssenceBar';
import styles from './GameOverlayTargetEssence.module.scss';

/** The run's main target's essence, across the top of the HUD; nothing in a run without one. */
export function GameOverlayTargetEssence(): JSX.Element | null {
    const { bridge } = useGameplay();
    const targetEssence = useGameSelector(bridge, (state) => state.targetEssence);

    if (targetEssence === null) {
        return null;
    }
    return (
        <div className={styles.topCenter}>
            <TargetEssenceBar
                className={styles.targetEssenceBar}
                name={targetEssence.name}
                value={targetEssence.essence}
                maxValue={targetEssence.maxEssence}
                color={targetEssence.color}
                message={targetEssence.message ?? undefined}
            />
        </div>
    );
}
